import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ThemeProvider from 'react-bootstrap/ThemeProvider';


const appRouting = (
  <ThemeProvider
    breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
    minBreakpoint="xxs"
  >
    <Router>
      <Routes>
        <Route path="/" element={<> test</>}>
          <Route index element={<> test</>} />
        </Route>
      </Routes>
    </Router>
  </ThemeProvider>
);
ReactDOM.render(appRouting, document.getElementById('root'));
